// extracted by mini-css-extract-plugin
export default {"container":"search_container__2USVD","content":"search_content__FoOfX"};